export const createToggleModalOpen = setModalOpen => () => setModalOpen(prevIsOpen => !prevIsOpen);
